
import React from 'react';
import _ from 'lodash';

export default class Grid extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        var classes = ['layout', this.props.className];
        var tdStyle = {
            width: (1 / this.props.columns * 100).toString() + '%'
        };

        var items = [...this.props.children];
        var rows = _(_.range(Math.ceil(items.length / this.props.columns))).map((rowId) => {
            var columns = [];
            var maxColumns = this.props.columns;
            while (maxColumns && items.length) {
                var item = items.shift();
                columns.push(
                    <td key={maxColumns} style={tdStyle}>{item}</td>
                );
                maxColumns--;
            }
            if (this.props.useEndPadding && maxColumns) {
                columns.push(
                    <td key={maxColumns+'-span'} colSpan={maxColumns}>&nbsp;</td>
                );
            }

            return <tr key={rowId}>{columns}</tr>;
        }).value();

        return <table className={classes.join(' ')}>
            <tbody>{rows}</tbody>
        </table>;
    }

}

Grid.defaultProps = {
    columns: 1
};
